import { render, staticRenderFns } from "./pluginPropView.vue?vue&type=template&id=40ce827a&"
import script from "./pluginPropView.vue?vue&type=script&lang=ts&"
export * from "./pluginPropView.vue?vue&type=script&lang=ts&"
import style0 from "./pluginPropView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports